<div class="video-popup-wrapper">
  <h2 mat-dialog-title>{{ popupData.title }}</h2>

  <div class="video-wrapper">
    <iframe
      *ngIf="vimeoUrl; else youtubeVideo"
      [src]="vimeoUrl"
      frameborder="0"
      width="640"
      height="360"
      allow="autoplay"
      [title]="popupData.title"
      allowfullscreen
    ></iframe>

    <ng-template #youtubeVideo>
      <div #videoWrapper></div>
    </ng-template>
  </div>

  <button mat-icon-button mat-dialog-close tabindex="0" aria-label="close">
    <mat-icon>close</mat-icon>
  </button>
</div>
